import { useEffect, useState } from "react";
import api from "../services/api";

export const DEFAULT_META_GRAPH_VERSION = "v26.0";

const EMPTY_PLATFORM = {
  version: DEFAULT_META_GRAPH_VERSION,
  appId: "",
  whatsappAppId: "",
  whatsappConfigId: "",
};

let cachedPlatform = null;
let pendingRequest = null;

export const fetchMetaPlatform = async () => {
  if (cachedPlatform) return cachedPlatform;
  if (!pendingRequest) {
    pendingRequest = api
      .get("/meta-graph-version")
      .then(({ data }) => {
        cachedPlatform = { ...EMPTY_PLATFORM, ...(data || {}) };
        return cachedPlatform;
      })
      .catch(() => EMPTY_PLATFORM)
      .finally(() => {
        pendingRequest = null;
      });
  }
  return pendingRequest;
};

export const fetchMetaGraphVersion = async () => (await fetchMetaPlatform()).version;

export const setCachedMetaPlatform = (platform) => {
  cachedPlatform = { ...EMPTY_PLATFORM, ...platform };
};

export const useMetaPlatform = () => {
  const [platform, setPlatform] = useState(cachedPlatform || EMPTY_PLATFORM);

  useEffect(() => {
    let alive = true;
    fetchMetaPlatform().then((value) => {
      if (alive) setPlatform(value);
    });
    return () => {
      alive = false;
    };
  }, []);

  return platform;
};

const useMetaGraphVersion = () => useMetaPlatform().version;

export default useMetaGraphVersion;
